import Links from 'react-router-innerhtml-links'

export default class ViddaLinks extends Links {

  navigate(e: MouseEvent) : void {
    e.preventDefault();

    // Get href from elem
    const href = (e.currentTarget as HTMLAnchorElement).getAttribute('href');

    // New tab check
    const isUpload = href.includes('/uploads/');

    if (isUpload) {
      window.open(href);
    } else {
      super.navigate(e);
    }
  }
}